import React, { memo } from 'react';

import { FormControl, FormControlLabel, Switch } from '@mui/material';
import PropTypes from 'prop-types';

import { ItemLabelPlacement } from 'constants/ui';

import FieldWrapper from '../../form/FieldWrapper';
import HelperText from '../../form/HelperText';

import { getFormControlLabelStyles } from './FormGeneratorSwitchCDS.styles';

const FormGeneratorSwitchCDS = ({
  value = null,
  label,
  labelPlacement = ItemLabelPlacement.START,
  customStyles = null,
  isFieldChanged = false,
  columns = 1,
  containerClassName = '',
  error = false,
  fullWidth = false,
  width,
  helperText = '',
  isHidden = false,
  dataTestId,
  ...restProps
}) => {
  return (
    <FormControl
      className={containerClassName}
      columns={columns}
      component={FieldWrapper}
      customStyles={customStyles}
      error={error}
      fullWidth={fullWidth}
      isHidden={isHidden}
      width={width}
    >
      <FormControlLabel
        checked={value}
        control={<Switch checked={value} data-testid={dataTestId} {...restProps} />}
        label={label}
        labelPlacement={labelPlacement}
        sx={getFormControlLabelStyles({ customStyles, isFieldChanged, columns })}
      />
      <HelperText error={error}>{helperText}</HelperText>
    </FormControl>
  );
};

FormGeneratorSwitchCDS.propTypes = {
  onChange: PropTypes.func.isRequired,
  customStyles: PropTypes.object,
  name: PropTypes.string,
  labelPlacement: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool,
  isFieldChanged: PropTypes.bool,
  isHidden: PropTypes.bool,
  columns: PropTypes.number,
  containerClassName: PropTypes.string,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  width: PropTypes.string,
  helperText: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default memo(FormGeneratorSwitchCDS);
